/**
 * url.ts
 *
 * Centralized URL configuration and helpers.
 * Set VITE_APP_URL in your .env file to your production domain.
 *
 * Example .env:
 *   VITE_APP_URL=https://barberstudioluisfer.com
 */

export const baseUrl: string =
  (import.meta.env.VITE_APP_URL as string | undefined)?.replace(/\/$/, '') ?? '';

/**
 * Build an absolute URL from a path.
 *
 * @param path - Must start with '/' (e.g. '/booking', '/services')
 * @returns Full URL string: baseUrl + path
 *
 * @example
 * getUrl('/booking') // → 'https://barberstudioluisfer.com/booking'
 */
export function getUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
}
